import { createRoot } from 'react-dom/client';
import App from './Root/App.tsx';
import './index.scss';
import { setEnv } from '@esg/shared';
import { env } from './configs/env.ts';

setEnv(env);
createRoot(document.getElementById('root')!).render(
  <App />,
);
